module.exports = __webpack_public_path__ + "static/img/nbtm.d4deea11.png";